module.exports = __webpack_public_path__ + "img/Molecule_to_mic.f2986741.gif";